import {createReducer} from '@reduxjs/toolkit'
import {DemoEvents} from '../types/state'

const defaultState: DemoEvents = {} as DemoEvents

export const demoEvents = createReducer(defaultState, () => {})
